import { Assigned } from './Assigned'
import { Created } from './Created'
import { Personal } from './Personal'

export const Tasks = {
  Assigned,
  Created,
  Personal,
}
